import { Menu } from "antd";
import {
  AppstoreOutlined,
  SettingOutlined,
  LoginOutlined,
  UserOutlined,
  UserSwitchOutlined,
  DollarOutlined,
  ScheduleOutlined,
  WindowsOutlined,
} from "@ant-design/icons";

import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { delUser } from "../../app/features/user/userSlice";

const { SubMenu } = Menu;

export default function MenuBarTest() {
  const user = useSelector((state) => {
    return state.user;
  });

  const location = useLocation();
  const dispatch = useDispatch();

  const [current] = useState(location.pathname);
  // console.log(user)
  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <div style={{ flex: 5 }}>
        <Menu selectedKeys={[current]} mode="horizontal">
          <Menu.Item key="/saleOnline" icon={<WindowsOutlined />}>
            <Link to="/saleOnline/test">ປະກັນໄພລົດທົ່ວໄປ</Link>
          </Menu.Item>
          {/* <Menu.Item key="/saleOnline/sellpac" icon={<AppstoreOutlined />}>
            <Link to="/saleOnline/sellpac">ປະກັນໄພລົດແບບແພັກແກັດ</Link>
          </Menu.Item> */}

          {/* <SubMenu
            key="/saleOnline/marketing"
            icon={<SettingOutlined />}
            title="ສະຫຼຸບການຂາຍ"
          >
            <Menu.ItemGroup title="ການຕະຫລາດ">
              <Menu.Item key="/saleOnline/AccountFinance">
                {" "}
                <Link to="/saleOnline/AccountFinance">
                  ການຂາຍ ປະກັນໄພລົດ
                </Link>{" "}
              </Menu.Item>
            </Menu.ItemGroup>
          </SubMenu> */}

          <Menu.Item key="/AccountFinanceTest" icon={<LoginOutlined />}>
            <Link
              to="/saleOnline/AccountFinanceTest"
            >
              ສະຫຼຸບການຂາຍ
            </Link>
          </Menu.Item>
          <Menu.Item key="/login" icon={<LoginOutlined />}>
            <Link
              to="/saleOnline/login"
            >
              ເຂົ້າສູ່ລະບົບ ການຂາຍ
            </Link>
          </Menu.Item>
          <Menu.Item key="/logins" icon={<LoginOutlined />}>
            <a href="http://zhongjiinsurance.com/">
              ກັບຄືນໜ້າເວັບ
            </a>
          </Menu.Item>

        </Menu>
      </div>


    </div>
  );
}
